import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const RemoveAddressBtn = ({ onClick }) => {
  const { t } = useTranslation('common')

  return (
    <a className='obrisi-model-btn removeBtn' onClick={onClick}>
      <span className='obrisi-model'>[-]</span> {t('Obriši ovu adresu')}
    </a>
  )
}

RemoveAddressBtn.propTypes = {
  onClick: PropTypes.func.isRequired
}
